import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Setup",
  "description": "Setup for Valkey using AWS ElastiCache"
};
export let structuredData = {
  "contents": [{
    "heading": "prerequisites",
    "content": "An active AWS account"
  }, {
    "heading": "prerequisites",
    "content": "Basic familiarity with AWS services like EC2, ECS, and VPC"
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Create a Common VPCSet up a common Virtual Private Cloud (VPC) to ensure all your resources (like EC2, ECS) can connect to Valkey."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Navigate to ElastiCacheGo to the Amazon ElastiCache Console."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Create a Cache"
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Click \"Create Cache\""
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Select Valkey as the engine"
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Choose Deployment Type"
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Select Serverless for a fully managed experience."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "If you prefer more control, choose the provisioned option (not covered in this guide)."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "In this example, we use serverless."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Configure Cache"
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Provide a name and optional description for your Valkey cache."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "In serverless mode, the VPC is auto-assigned using the subnets."
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Ensure Network Compatibility"
  }, {
    "heading": "how-to-set-up-valkey-on-aws",
    "content": "Make sure your EC2 instances, ECS tasks, or any other compute services are deployed within the same VPC (or can route to it)."
  }, {
    "heading": "connecting-to-valkey",
    "content": "Use a Standard Redis ClientValkey supports the Redis protocol, so any standard Redis client can be used to connect."
  }, {
    "heading": "connecting-to-valkey",
    "content": "Get Connection Details"
  }, {
    "heading": "connecting-to-valkey",
    "content": "After creating your Valkey instance, click on it in the ElastiCache console."
  }, {
    "heading": "connecting-to-valkey",
    "content": "Locate the endpoint, port, username, and password."
  }, {
    "heading": "connecting-to-valkey",
    "content": "Connect Example (CLI)"
  }],
  "headings": [{
    "id": "prerequisites",
    "content": "Prerequisites"
  }, {
    "id": "how-to-set-up-valkey-on-aws",
    "content": "How to Set Up Valkey on AWS"
  }, {
    "id": "connecting-to-valkey",
    "content": "Connecting to Valkey"
  }]
};
export const toc = [{
  depth: 2,
  url: "#prerequisites",
  title: _jsx(_Fragment, {
    children: "Prerequisites"
  })
}, {
  depth: 2,
  url: "#how-to-set-up-valkey-on-aws",
  title: _jsx(_Fragment, {
    children: "How to Set Up Valkey on AWS"
  })
}, {
  depth: 2,
  url: "#connecting-to-valkey",
  title: _jsx(_Fragment, {
    children: "Connecting to Valkey"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    br: "br",
    code: "code",
    h2: "h2",
    hr: "hr",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "prerequisites",
      children: "Prerequisites"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "An active AWS account"
      }), "\n", _jsx(_components.li, {
        children: "Basic familiarity with AWS services like EC2, ECS, and VPC"
      }), "\n"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "how-to-set-up-valkey-on-aws",
      children: "How to Set Up Valkey on AWS"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Create a Common VPC"
          }), _jsx(_components.br, {}), "\n", "Set up a common Virtual Private Cloud (VPC) to ensure all your resources (like EC2, ECS) can connect to Valkey."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Navigate to ElastiCache"
          }), _jsx(_components.br, {}), "\n", "Go to the ", _jsx(_components.a, {
            href: "https://console.aws.amazon.com/elasticache/",
            children: "Amazon ElastiCache Console"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Create a Cache"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Click ", _jsx(_components.strong, {
              children: "\"Create Cache\""
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["Select ", _jsx(_components.strong, {
              children: "Valkey"
            }), " as the engine"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Choose Deployment Type"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Select ", _jsx(_components.strong, {
              children: "Serverless"
            }), " for a fully managed experience."]
          }), "\n", _jsxs(_components.li, {
            children: ["If you prefer more control, choose the ", _jsx(_components.strong, {
              children: "provisioned"
            }), " option (not covered in this guide)."]
          }), "\n", _jsxs(_components.li, {
            children: ["In this example, we use ", _jsx(_components.strong, {
              children: "serverless"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Configure Cache"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Provide a ", _jsx(_components.strong, {
              children: "name"
            }), " and optional ", _jsx(_components.strong, {
              children: "description"
            }), " for your Valkey cache."]
          }), "\n", _jsxs(_components.li, {
            children: ["In serverless mode, the ", _jsx(_components.strong, {
              children: "VPC is auto-assigned"
            }), " using the subnets."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Ensure Network Compatibility"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["Make sure your ", _jsx(_components.strong, {
              children: "EC2 instances"
            }), ", ", _jsx(_components.strong, {
              children: "ECS tasks"
            }), ", or any other compute services are deployed within the ", _jsx(_components.strong, {
              children: "same VPC"
            }), " (or can route to it)."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.h2, {
      id: "connecting-to-valkey",
      children: "Connecting to Valkey"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Use a Standard Redis Client"
          }), _jsx(_components.br, {}), "\n", "Valkey supports the Redis protocol, so any standard Redis client can be used to connect."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Get Connection Details"
          })
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "After creating your Valkey instance, click on it in the ElastiCache console."
          }), "\n", _jsxs(_components.li, {
            children: ["Locate the ", _jsx(_components.strong, {
              children: "endpoint"
            }), ", ", _jsx(_components.strong, {
              children: "port"
            }), ", ", _jsx(_components.strong, {
              children: "username"
            }), ", and ", _jsx(_components.strong, {
              children: "password"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "Connect Example (CLI)"
          })
        }), "\n", _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes github-light github-dark",
            style: {
              "--shiki-light": "#24292e",
              "--shiki-dark": "#e1e4e8",
              "--shiki-light-bg": "#fff",
              "--shiki-dark-bg": "#24292e"
            },
            tabIndex: "0",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "#6F42C1",
                    "--shiki-dark": "#B392F0"
                  },
                  children: "redis-cli"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#005CC5",
                    "--shiki-dark": "#79B8FF"
                  },
                  children: " -h"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: " <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#032F62",
                    "--shiki-dark": "#9ECBFF"
                  },
                  children: "endpoin"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#24292E",
                    "--shiki-dark": "#E1E4E8"
                  },
                  children: "t"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: ">"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#005CC5",
                    "--shiki-dark": "#79B8FF"
                  },
                  children: " -p"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: " <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#032F62",
                    "--shiki-dark": "#9ECBFF"
                  },
                  children: "por"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#24292E",
                    "--shiki-dark": "#E1E4E8"
                  },
                  children: "t"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: ">"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#005CC5",
                    "--shiki-dark": "#79B8FF"
                  },
                  children: " -a"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: " <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#032F62",
                    "--shiki-dark": "#9ECBFF"
                  },
                  children: "passwor"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#24292E",
                    "--shiki-dark": "#E1E4E8"
                  },
                  children: "d"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: ">"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#005CC5",
                    "--shiki-dark": "#79B8FF"
                  },
                  children: " --user"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: " <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#032F62",
                    "--shiki-dark": "#9ECBFF"
                  },
                  children: "usernam"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#24292E",
                    "--shiki-dark": "#E1E4E8"
                  },
                  children: "e"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "#D73A49",
                    "--shiki-dark": "#F97583"
                  },
                  children: ">"
                })]
              })
            })
          })
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
